import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '@/lib/hooks';

export default function SectionHeading({ eyebrow, title, subtitle, align = 'center', onDark = false, children }) {
  const [ref, inView] = useInView({ threshold: 0.3, once: true });
  const alignClass = align === 'left' ? 'text-left items-start' : 'text-center items-center';
  return (
    <div
      ref={ref}
      className={`flex flex-col ${alignClass} max-w-3xl ${align === 'center' ? 'mx-auto' : ''} mb-12 md:mb-16`}
    >
      {eyebrow && (
        <motion.span
          className={`eyebrow ${onDark ? 'on-dark' : ''} mb-5`}
          initial={{ opacity: 0, y: 6 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.45 }}
        >
          {eyebrow}
        </motion.span>
      )}
      <motion.h2
        className={`section-heading ${onDark ? 'on-dark' : ''} text-3xl sm:text-4xl md:text-[2.75rem] leading-[1.08] mb-4`}
        initial={{ opacity: 0, y: 10 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.55, delay: 0.05 }}
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          className={`text-[15.5px] md:text-base leading-relaxed max-w-2xl ${onDark ? 'text-white/70' : 'text-[color:var(--sh-muted)]'}`}
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.55, delay: 0.15 }}
        >
          {subtitle}
        </motion.p>
      )}
      {children}
    </div>
  );
}
